import React from 'react';

// Small pieces shared by the Settings sections, in the app's ink/surface tokens.
export const panel = { background: 'var(--surf-surface)', borderColor: 'var(--surf-line)' };
export const kicker = 'font-mono text-[10.5px] font-medium tracking-[0.12em]';

export function Switch({ on, onChange, label, disabled }) {
  return (
    <button type="button" role="switch" aria-checked={!!on} aria-label={label} disabled={disabled} onClick={() => onChange(!on)}
      className="relative w-11 h-[26px] shrink-0 p-0 rounded-[13px] border disabled:opacity-50"
      style={{ background: on ? 'var(--accent)' : 'var(--surf-raised)', borderColor: on ? 'var(--accent)' : 'var(--surf-line-strong)' }}>
      <span className="absolute top-[3px] w-[18px] h-[18px] rounded-full transition-[left]" style={{ left: on ? 22 : 3, background: on ? '#0A0A0A' : 'var(--ink-muted)' }} />
    </button>
  );
}

export function StatusChip({ ok, text }) {
  const tok = ok === true ? 'good' : ok === false ? 'crit' : 'low';
  return (
    <span className="inline-flex items-center gap-[5px] h-[22px] px-[7px] rounded-md font-mono text-[9.5px] font-medium tracking-[0.06em] whitespace-nowrap" style={{ background: `var(--sev-${tok}-bg)` }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: `var(--sev-${tok}-fg)` }} />{text}
    </span>
  );
}

export function Notice({ kind = 'error', children }) {
  const tok = kind === 'error' ? 'crit' : kind === 'warn' ? 'high' : 'good';
  return <div role={kind === 'error' ? 'alert' : 'status'} className="px-3.5 py-2.5 rounded-[10px] border text-[13px] leading-normal" style={{ borderColor: `var(--sev-${tok}-fg)`, background: `var(--sev-${tok}-bg)`, color: 'var(--ink-text)' }}>{children}</div>;
}

export function SectionHead({ title, sub, right }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div className="flex flex-col gap-1.5"><h2 className="m-0 font-heading text-[21px] font-semibold">{title}</h2>{sub && <p className="m-0 text-[13.5px]" style={{ color: 'var(--ink-muted)' }}>{sub}</p>}</div>
      {right}
    </div>
  );
}

export const Mono = ({ children }) => <span className="font-mono text-[12px]">{children}</span>;
